import styled from "@emotion/styled";
import { motion } from "framer-motion";
import theme from "../../../../theme";

// const Card = styled(motion.div)`
//   display: flex;
//   align-items: center;
//   background: white;
//   border: 1px solid ${theme.colors.border};
//   border-radius: 8px;
//   padding: 15px;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
//   transition: box-shadow 0.2s;
//   will-change: transform;

//   &:hover {
//     transform: scale(1.05);
//     box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
//   }
// `;

const Card = styled(motion.div)`
  display: flex;
  align-items: left;
  background: ${theme.colors.text.quaternary};
  border: 1px solid ${theme.colors.text.quinary};
  border-radius: 16px;
  padding: 15px;
  flex-direction: column;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition:
    transform 0.2s ease,
    box-shadow 0.3s ease;
  backface-visibility: hidden;

  &:hover {
    transform: scale(1.05) translateZ(0); /* apply GPU only on hover */
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    border-color: ${theme.colors.primary};
  }
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.colors.border};
  border-radius: 25%;
  margin-right: 1rem;
  background-color: rgba(247, 250, 252, 0.05);

  svg {
    width: 30px;
    height: 20px;
  }
`;

const Content = styled.div`
  text-align: left;
`;

const Title = styled.p`
  color: ${theme.colors.text.primary};
  font-family: "Inter", sans-serif;
  font-weight: bold;
  &:hover {
    color: ${theme.colors.primary};
  }
`;

const Description = styled.p`
  font-size: 1rem;
  font-weight: 400; /* regular */
  color: ${theme.colors.text.tertiary};
  font-family: "Inter Regular", "Inter", sans-serif;
  letter-spacing: -0.4px;
`;

const TryItButton = styled.a`
  font-size: 15px;
  color: ${theme.colors.primary};
  font-weight: 500;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  font-family: "Inter", sans-serif;

  span {
    margin-left: 0.3rem;
  }
`;

const SC = {
  Card,
  IconWrapper,
  Content,
  Title,
  Description,
  TryItButton,
};

export default SC;
